import { I as i } from "../../constants-DeVuDy8J.js";
import { openBlock as d, createElementBlock as l, normalizeClass as n, createElementVNode as o } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconGifFilled",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(i).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return i[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, f = ["aria-label", "data-qa", "aria-hidden"];
function m(e, t, r, u, v, a) {
  return d(), l("svg", {
    "aria-label": r.ariaLabel,
    class: n([a.iconSizeClass, "d-icon d-icon--gif-filled"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Gif Filled",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [...t[0] || (t[0] = [
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M2.5 1.063c-.794 0-1.437.644-1.437 1.437v7c0 .794.643 1.438 1.437 1.438h7c.794 0 1.438-.644 1.438-1.438v-7c0-.793-.644-1.437-1.438-1.437h-7ZM4 4.313c-.794 0-1.437.644-1.437 1.437v.5c0 .794.643 1.438 1.437 1.438h.5a.437.437 0 0 0 .438-.438V6a.437.437 0 0 0-.438-.437h-.25a.437.437 0 0 0-.187.833v.417H4a.563.563 0 0 1-.562-.563v-.5c0-.31.252-.562.562-.562h.5a.437.437 0 1 0 0-.875H4Zm2.438.437a.437.437 0 1 0-.875 0v2.5a.438.438 0 0 0 .875 0v-2.5ZM7.5 4.313a.437.437 0 0 0-.437.437v2.5a.438.438 0 0 0 .875 0v-.812H8.5a.437.437 0 1 0 0-.875h-.562v-.375H9a.437.437 0 1 0 0-.875H7.5Z",
      fill: "currentColor"
    }, null, -1)
  ])], 10, f);
}
const g = /* @__PURE__ */ s(c, [["render", m]]);
export {
  g as default
};
//# sourceMappingURL=gif-filled.js.map
